export default class Errors {
  /**
   * Create a new Errors instance.
   */
  constructor() {
    this.errors = {};
    this.focusOnErrorInput = true;
    this.errorAutoscroll = true;
    this.erorrsPopup = true;
  }


  /**
   * Determine if an errors exists for the given field.
   *
   * @param {string} field
   */
  has(field) {
    return this.errors.hasOwnProperty(field);
  }


  /**
   * Determine if we have any errors.
   */
  any() {
    return Object.keys(this.errors).length > 0;
  }


  /**
   * Retrieve the error message for a field.
   *
   * @param {string} field
   */
  get(field) {
    if (this.errors[field]) {
      if (Array.isArray(this.errors[field])) {
        return this.errors[field][0];
      }

      return this.errors[field];
    }
  }


  /**
   * Record the new errors.
   *
   * @param {object} errors
   */
  record(errors) {
    this.errors = errors;

    if (this.focusOnErrorInput) {
      this.setErrorFocus();
    }

    if (this.errorAutoscroll) {
      this.autoscrollToError();
    }

    if (this.erorrsPopup) {
      this.showErrorsPopup();
    }
  }


  /**
   * Clear one or all error fields.
   *
   * @param {string|null} field
   */
  clear(field) {
    if (field) {
      Vue.delete(this.errors, field);

      return;
    }

    this.errors = {};

  }

  /**
   * Set focus on the input which has an error
   *
   */
  setErrorFocus() {
    let fieldName = Object.keys(this.errors)[0];

    if (!fieldName) return;

    let element = $(`*[name='${fieldName}']`);
    if (!element) return;

    element.focus();
    if (CKEDITOR && CKEDITOR.instances[fieldName]) {
      CKEDITOR.instances[fieldName].focus();
    }
  }

  /**
   * Autoscroll to the input which has an error
   *
   */
  autoscrollToError() {
    let fieldName = Object.keys(this.errors)[0];
    if (!fieldName) return;

    let element = $(`*[name='${fieldName}']`);
    if (element.length === 0) return;

    if (window.pageYOffset < element.offset().top) return;

    let container = $('html, body');
    container.animate({
      scrollTop: element.offset().top - 100
    });
  }

  /**
   * Show popup with errors
   *
   */
  showErrorsPopup() {
    let errors = this.errors,
      allErrorMessages = [];

    if (errors.hasOwnProperty('errors')) {
      errors = errors.errors;
    }

    for (let prop in errors) {
      let specificErrors = errors[prop];

      allErrorMessages.push(specificErrors[0]);
    }
  }

  setFocusOnErrorInput(value) {
    this.focusOnErrorInput = value;
  }

  setAutoscrollToErrors(value) {
    this.errorAutoscroll = value;
  }

  setErrorsPopup(value) {
    this.erorrsPopup = value;
  }
}